import { render, staticRenderFns } from "./ProcurementResolveRFMToNewPO.vue?vue&type=template&id=46cfb604&"
import script from "./ProcurementResolveRFMToNewPO.vue?vue&type=script&lang=js&"
export * from "./ProcurementResolveRFMToNewPO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports